document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelectorAll('.multi-step-form').length > 0) {
        
        // Skip if this is a booking form (handled by form-booking-app.js)
        if (document.querySelector('.form-bookingapp')) {
            return;
        }

        const form = document.querySelector('.multi-step-form');
        const steps = form.querySelectorAll('.step');
        const stepIndicators = form.querySelectorAll('.step-indicator');
        let currentStep = 1;

        // Function to show the current step
        function showStep(stepNumber) {
            steps.forEach(step => {
                step.classList.add('d-none');
                if (parseInt(step.getAttribute('data-step')) === stepNumber) {
                    step.classList.remove('d-none');
                }
            });

            // Update progress indicator
            stepIndicators.forEach(indicator => {
                const indicatorStep = parseInt(indicator.getAttribute('data-step'));
                indicator.classList.remove('active');

                // Add active class to current step and all previous steps
                if (indicatorStep <= stepNumber) {
                    indicator.classList.add('active');
                }
            });

            currentStep = stepNumber;
        }

        // Function to validate current step
        function validateStep(stepNumber) {
            const currentStepEl = form.querySelector(`.step[data-step="${stepNumber}"]`);
            const inputs = currentStepEl.querySelectorAll('input[required], select[required], textarea[required]');
            let isValid = true;

            inputs.forEach(input => {
                if (!input.checkValidity()) {
                    input.classList.add('is-invalid');
                    isValid = false;
                } else {
                    input.classList.remove('is-invalid');
                }
            });

            return isValid;
        }

        // Next button logic
        form.querySelectorAll('.next-step').forEach(button => {
            button.addEventListener('click', () => {
                if (validateStep(currentStep)) {
                    if (currentStep < steps.length) {
                        showStep(currentStep + 1);
                    }
                }
            });
        });

        // Previous button logic
        form.querySelectorAll('.prev-step').forEach(button => {
            button.addEventListener('click', () => {
                if (currentStep > 1) {
                    showStep(currentStep - 1);
                }
            });
        });

        // Form submission
        form.addEventListener('submit', (e) => {
            if (!validateStep(currentStep)) {
                e.preventDefault();
                e.stopPropagation();
            } else {
                form.classList.add('was-validated');
            }
        });

        // Initialize first step
        showStep(1);
    }
});